<template>
  <section class="card my-vehicles">
    <div class="sec-t">
      <span class="ico"><i class="el-icon-truck" /></span>
      我的车辆
      <span class="right">共 {{ listQuery.total }} 辆</span>
    </div>

    <div class="mv-filter">
      <div class="mv-item mv-item-lg">
        <label>车牌号</label>
        <el-input
          v-model.trim="listQuery.licenseNumber"
          size="small"
          clearable
          placeholder="请输入车牌号"
          @keyup.enter.native="funcFilter"
        />
      </div>
      <div class="mv-item">
        <label>是否主驾</label>
        <el-select v-model="listQuery.isMaster" size="small" clearable placeholder="全部">
          <el-option :value="1" label="是" />
          <el-option :value="0" label="否" />
        </el-select>
      </div>
      <div class="mv-item">
        <label>审核状态</label>
        <el-select v-model="listQuery.authStatus" size="small" clearable placeholder="全部">
          <el-option :value="0" label="未审核" />
          <el-option :value="1" label="审核中" />
          <el-option :value="2" label="审核未通过" />
          <el-option :value="3" label="审核通过" />
        </el-select>
      </div>
      <div class="mv-item">
        <label>车辆性质</label>
        <el-select v-model="listQuery.vehicleNature" size="small" clearable placeholder="全部">
          <el-option
            v-for="item in vehicleTypeOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </div>
      <div class="mv-item">
        <label>协议</label>
        <el-select v-model="listQuery.agreementStatus" size="small" clearable placeholder="全部">
          <el-option :value="0" label="未上传" />
          <el-option :value="1" label="已上传" />
        </el-select>
      </div>
      <div class="mv-item">
        <label>是否确认</label>
        <el-select v-model="listQuery.isConfirmed" size="small" clearable placeholder="全部">
          <el-option :value="1" label="是" />
          <el-option :value="0" label="否" />
        </el-select>
      </div>
      <div class="mv-actions">
        <el-button size="small" type="primary" @click="funcFilter">查询</el-button>
        <el-button size="small" @click="showAddCollectionModel">添加代收协议</el-button>
        <el-button size="small" @click="funcExport">导出</el-button>
      </div>
    </div>

    <div v-loading="loading" class="mv-table-wrap">
      <table class="mv-table">
        <thead>
          <tr>
            <th>车牌号</th>
            <th>是否主驾</th>
            <th>审核状态</th>
            <th>车辆性质</th>
            <th>协议</th>
            <th>是否确认</th>
            <th class="mv-op">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in tableData" :key="row.id || row.code">
            <td>{{ row.licenseNumber || "--" }}</td>
            <td :class="row.isMaster === 1 ? 'is-yes' : 'is-no'">{{ row.isMaster === 1 ? "是" : "否" }}</td>
            <td>{{ row.authStatusText || "--" }}</td>
            <td>{{ row.vehicleNatureText || "--" }}</td>
            <td :class="row.agreementStatus === 1 ? 'is-yes' : 'is-no'">{{ row.agreementStatusText || "--" }}</td>
            <td :class="row.isConfirmed === 1 ? 'is-yes' : 'is-no'">{{ row.isConfirmed === 1 ? "是" : "否" }}</td>
            <td class="mv-op">
              <button class="mv-link" type="button" @click="showCollectionAgreementModel(row)">查看协议</button>
            </td>
          </tr>
          <tr v-if="!loading && !tableData.length">
            <td class="mv-empty" colspan="7">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="listQuery.total > listQuery.pageSize" class="mv-pager">
      <el-pagination
        background
        layout="prev, pager, next, sizes, total"
        :current-page="listQuery.pageNum"
        :page-size="listQuery.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="listQuery.total"
        @current-change="onPageChange"
        @size-change="onSizeChange"
      />
    </div>

    <el-dialog
      title="添加代收协议"
      :visible.sync="addCollectionFlag"
      width="420px"
      append-to-body
      custom-class="add-collection-dialog"
    >
      <add-collection-agreement
        v-if="addCollectionFlag"
        ref="addCollectionAgreementRef"
        @hideModel="hideAddCollectionModel"
      />
    </el-dialog>

    <el-dialog
      title="查看协议"
      :visible.sync="collectionAgreementFlag"
      width="800px"
      append-to-body
    >
      <el-form v-if="collectionAgreementFlag" class="vehicle-agreement-form">
        <div class="form-section">
          <h3>车辆性质</h3>
          <el-radio-group v-model="vehicleNature">
            <el-radio
              v-for="item in vehicleTypeOptions"
              :key="item.code"
              :label="item.code"
            >{{ item.name }}</el-radio>
          </el-radio-group>
        </div>
        <div class="form-section">
          <h3>上传协议</h3>
          <multiple-upload
            :required="false"
            :max-count="10"
            :disabled="false"
            :img-list.sync="imgList"
            @totalSuccess="totalSuccess"
          />
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="collectionAgreementFlag = false">取消</el-button>
        <el-button type="primary" @click="uploadVehicleAgreementApi">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import request from "@/utils/request";
import { download } from "@/utils";
import { VehicleType, uploadVehicleAgreement } from "@/api/orderform";
import multipleUpload from "@/components/ImgUpload/multipleUpload.vue";
import addCollectionAgreement from "@/views/basicInfo/driver/driverManage/components/vehicleTeam/collectionAgreementLogAdd.vue";

export default {
  name: "DriverMyVehicles",
  components: { multipleUpload, addCollectionAgreement },
  props: {
    partyCode: { type: String, default: "" }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      vehicleTypeOptions: [],
      vehicleNature: "",
      imgList: [],
      rowObj: {},
      addCollectionFlag: false,
      collectionAgreementFlag: false,
      listQuery: {
        partyCode: "",
        licenseNumber: "",
        isMaster: "",
        authStatus: "",
        vehicleNature: "",
        agreementStatus: "",
        isConfirmed: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  watch: {
    partyCode: {
      immediate: true,
      handler(val) {
        if (val) {
          this.listQuery.partyCode = val;
          this.findList();
        }
      }
    }
  },
  methods: {
    findList() {
      if (!this.listQuery.partyCode) {
        return Promise.resolve();
      }
      this.loading = true;
      return this.loadNatureOptions()
        .then(() =>
          request({
            url: "/ntocc-basic-api/driver/vehicleList",
            method: "get",
            params: this.listQuery
          })
        )
        .then(response => {
          const data = response.data || {};
          this.tableData = data.records || [];
          this.listQuery.total = data.total || 0;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadNatureOptions() {
      if (this.vehicleTypeOptions.length) {
        return Promise.resolve();
      }
      return VehicleType({ type: "vehicleNature" }).then(response => {
        this.vehicleTypeOptions = (response.data && response.data.records) || [];
      });
    },
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    onPageChange(page) {
      this.listQuery.pageNum = page;
      this.findList();
    },
    onSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.pageNum = 1;
      this.findList();
    },
    funcExport() {
      if (!this.listQuery.total) {
        this.$message.warning("暂无可导出的数据");
        return;
      }
      const params = Object.assign({}, this.listQuery, {
        pageNum: 1,
        pageSize: this.listQuery.total
      });
      const loading = this.$loading({ lock: true, text: "正在导出..." });
      this.exportFn("/ntocc-basic-api/driver/exportJoinedTeamList", params, "get")
        .then(res => {
          download(res, "我的车队");
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    showAddCollectionModel() {
      this.addCollectionFlag = true;
      this.$nextTick(() => {
        if (this.$refs.addCollectionAgreementRef) {
          this.$refs.addCollectionAgreementRef.init(this.listQuery.partyCode);
        }
      });
    },
    hideAddCollectionModel() {
      this.addCollectionFlag = false;
      this.findList();
    },
    showCollectionAgreementModel(row) {
      this.rowObj = row;
      this.imgList = row.agreementUrls || [];
      this.vehicleNature = row.vehicleNature + "";
      this.collectionAgreementFlag = true;
    },
    uploadVehicleAgreementApi() {
      uploadVehicleAgreement({
        code: this.rowObj.code,
        vehicleNature: this.vehicleNature,
        urls: [...this.imgList]
      }).then(() => {
        this.$message({ message: "上传成功", type: "success" });
        this.findList();
        this.collectionAgreementFlag = false;
      });
    },
    totalSuccess() {}
  }
};
</script>

<style lang="scss" scoped>
.my-vehicles {
  .sec-t {
    display: flex;
    align-items: center;
    gap: 11px;
    font-size: 16.5px;
    font-weight: 600;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .ico {
      width: 30px;
      height: 30px;
      border-radius: 9px;
      background: #eef4ff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: none;

      i {
        font-size: 17px;
        color: #2f6bff;
      }
    }

    .right {
      margin-left: auto;
      font-size: 12.5px;
      color: #8a93a6;
      font-weight: 400;
    }
  }

  .mv-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
    padding: 4px 0 14px;
    border-bottom: 1px solid #f0f1f3;
  }

  .mv-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 128px;
    flex: 1;

    label {
      color: #667085;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
    }

    &.mv-item-lg {
      flex: 1.6;
      min-width: 200px;
    }
  }

  .mv-actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
    flex: none;
  }

  .mv-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
    margin-top: 12px;

    th {
      text-align: left;
      color: #95a3b7;
      font-weight: 500;
      padding: 10px 12px;
      background: #f7f9fc;
      border-bottom: 1px solid #f0f1f3;
      white-space: nowrap;
    }

    td {
      padding: 12px;
      border-bottom: 1px solid #eff1f5;
      color: #1d1f2c;
    }

    tbody tr:hover td {
      background: #f9fafc;
    }

    .mv-op {
      text-align: right;
      white-space: nowrap;
    }

    .is-yes {
      color: #0e9f6e;
    }

    .is-no {
      color: #98a2b3;
    }

    .mv-empty {
      text-align: center;
      padding: 40px 0;
      color: #c2c9d8;
    }
  }

  .mv-link {
    border: none;
    background: none;
    color: #2e5ff0;
    cursor: pointer;
    font-size: 13px;
    font-family: inherit;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  }

  .mv-pager {
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
  }

  .vehicle-agreement-form {
    padding: 4px 8px;

    .form-section {
      margin-bottom: 20px;

      h3 {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 12px;
      }
    }

    .el-radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
    }
  }
}
</style>

<style lang="scss">
/* 「添加代收协议」弹窗：整体加高（el-dialog 挂到 body，需非 scoped 样式） */
.add-collection-dialog {
  .el-dialog__body {
    min-height: 360px;
  }
}
</style>
